import { z } from 'zod'

import { PrimaryContractDeployment } from '../../../cross-chain-deployment/PrimaryContractDeployment'
import * as SaltSchema from './SaltSchema'
import * as FundingAmountSchema from './FundingAmountSchema'
import * as ImplementationContractSchema from './ImplementationContractSchema'
import * as InitializationCalldataSchema from './InitializationCalldataSchema'

export const PrimaryContractDeploymentSchema = z.object({
  salt: SaltSchema.SaltSchema,
  fundingAmount: FundingAmountSchema.FundingAmountSchema,
  implementationContract:
    ImplementationContractSchema.ImplementationContractSchema,
  initializationCalldata:
    InitializationCalldataSchema.InitializationCalldataSchema,
})

type PrimaryContractDeploymentReportText = z.infer<
  typeof PrimaryContractDeploymentSchema
>

export function mapDomainToReportText(
  primaryContractDeployment: PrimaryContractDeployment
): PrimaryContractDeploymentReportText {
  return {
    salt: SaltSchema.mapDomainToReportText(primaryContractDeployment.getSalt()),
    fundingAmount: FundingAmountSchema.mapDomainToReportText(
      primaryContractDeployment.getFundingAmount()
    ),
    implementationContract: ImplementationContractSchema.mapDomainToReportText(
      primaryContractDeployment.getImplementationContract()
    ),
    initializationCalldata: InitializationCalldataSchema.mapDomainToReportText(
      primaryContractDeployment.getInitializationCalldata()
    ),
  }
}

export function mapReportTextToDomain(
  reportText: PrimaryContractDeploymentReportText
): PrimaryContractDeployment {
  const {
    salt,
    fundingAmount,
    implementationContract,
    initializationCalldata,
  } = reportText
  return new PrimaryContractDeployment({
    salt: SaltSchema.mapReportTextToDomain(salt),
    fundingAmount: FundingAmountSchema.mapReportTextToDomain(fundingAmount),
    implementationContract: ImplementationContractSchema.mapReportTextToDomain(
      implementationContract
    ),
    initializationCalldata: InitializationCalldataSchema.mapReportTextToDomain(
      initializationCalldata
    ),
  })
}
